import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramUGCManagementBasicInfo.graphql';
import { Query, QueryinstagramUGCManagementBasicInfoArgs } from '../../__generated__/globalTypes';

export const useInstagramUGCManagementBasicInfoQuery = (
  options?: QueryHookOptions<Query, QueryinstagramUGCManagementBasicInfoArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramUGCManagementBasicInfoArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramUGCManagementBasicInfoLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramUGCManagementBasicInfoArgs>
): QueryResult<Query, QueryinstagramUGCManagementBasicInfoArgs> & {
  getInstagramUGCManagementBasicInfo: LazyQueryExecFunction<Query, QueryinstagramUGCManagementBasicInfoArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramUGCManagementBasicInfo, result] = useLazyQuery<Query, QueryinstagramUGCManagementBasicInfoArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInstagramUGCManagementBasicInfo, ...result };
};

export const useInstagramUGCManagementBasicInfoPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramUGCManagementBasicInfo = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramUGCManagementBasicInfoArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramUGCManagementBasicInfoArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramUGCManagementBasicInfo };
};
// Suspense Query Hooks
export const useInstagramUGCManagementBasicInfoSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramUGCManagementBasicInfoArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramUGCManagementBasicInfoArgs>(QUERY, {
    ...options
  });

  return result;
};
